export const GET_HOME_RACES = 'GET_HOME_RACES';
